import React, { createContext, useCallback, useState } from 'react';
import { STORAGE } from '../../constants';
import { useAuth } from '../../hooks/useAuth';
import apiSSO from '~/utils/sso';
import { TelemetryContextData } from './types';

export const TelemetryContext = createContext<TelemetryContextData>(
  {} as TelemetryContextData,
);

export const TelemetryProvider: React.FC = ({ children }) => {
  const { signOut } = useAuth();

  const setStorage = (key: string, value: string) =>
    localStorage.setItem(`${STORAGE}:${key}`, value);

  const getStorage = (key: string) => localStorage.getItem(`${STORAGE}:${key}`);

  const urlChanged = useCallback(async (url: string) => {
    const dateTimeUrl = new Date().toISOString();

    const user = getStorage('user');
    const idHist = getStorage('idHist');

    if (user) {
      const { email } = JSON.parse(user);
      try {
        apiSSO
          .post('/user/hist', {
            nm_loginusuario: email,
            dh_entradaurl: dateTimeUrl,
            ds_url: window.location.pathname,
          })
          .then(response => setStorage('idHist', response.data.id_registrourl))
          .catch(console.error);

        if (idHist) {
          apiSSO.put(`/user/hist/${idHist}`, {
            dh_saidaurl: dateTimeUrl,
          });
        }
      } catch (e) {
        console.error(e);
      }
    }
  }, []);

  return (
    <TelemetryContext.Provider value={{ urlChanged }}>
      {children}
    </TelemetryContext.Provider>
  );
};
